export const environment = {
  production: true,
  envName: 'prod',
  baseFixUrl: 'https://www.fixdigital.co.il/',
  baseUrl: 'https://www.fixdigital.co.il/api/crm/webapp/v1/',
  baseUrlV1: "https://www.fixdigital.co.il/api/crm/webapp/v1/",
  baseUrlV2: "https://www.fixdigital.co.il/api/crm/webapp/v2/",
  version: "2.4.88"
};
